import { captureException } from '@sentry/react'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { judicialRecordQuery } from '@/state/judicial/judicialRecords'

export const Route = createFileRoute('/judicial/$recordId')({
  beforeLoad: async ({ context, params }) => {
    const { exists, data } = await context.queryClient.fetchQuery(judicialRecordQuery(params.recordId))
    if (!exists) {
      throw notFound()
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return { record: data! }
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
